// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Ey1U","text":"_1qEF-"};